import React from 'react';
import { Router, Switch, Route } from './routing';
import { Platform, Text, View, Linking, TouchableOpacity } from 'react-native';
import { Analytics, PageHit } from 'expo-analytics';

import GrammarTest from './GrammarTest.js';
import Lesson1 from './Lesson1.js';
import Index from './Index.js';
import Styles from './Styles.js'

export default function App() {
  if (__DEV__) {
    console.log("Dev mode")
    if(Platform.OS == "web"){
      const analytics = new Analytics('UA-89635433-5', {dr: document.referrer})
    }
    else{
      const analytics = new Analytics('UA-89635433-5')
    }
  }
  else{
    if(Platform.OS == "web"){
      const analytics = new Analytics('UA-89635433-5', {dr: document.referrer})
      analytics.hit(new PageHit('Home'))
    }
    else{
      const analytics = new Analytics('UA-89635433-5')
      analytics.hit(new PageHit('Home'))
    }
  }

  return (
    <Router>
      <View style={Styles.appContainer}>
        <View style={Styles.appBody}>
          <Switch>
            <Route path='/grammar_test' component={GrammarTest} />
            <Route path='/lesson1' component={Lesson1} />
            <Route path='/' component={GrammarTest} />
          </Switch>
        </View>
        <View style={Styles.appFooter}>
          <TouchableOpacity onPress= { () => Linking.openURL("https://www.slowserbian.com") }>
            <Text style={Styles.footerLinkText}>slowserbian.com</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Router>
  );
}
